export default __webpack_public_path__ + "91cffb9b35c55db3d8a8676a69fe45fd.png";